import { forwardRef, InputHTMLAttributes } from "react";

const Input = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement>
>(({ className, disabled, ...props }, ref) => {
  return (
    <input
      ref={ref}
      className={`text-md h-full w-full flex-1 rounded border border-gray-300 px-2 py-1.5 ${className} ${disabled ? "text-gray-300" : "text-gray-700"}`}
      disabled={disabled}
      {...props}
    />
  );
});

Input.displayName = "Input";

export default Input;
